import { isPlainObject } from 'shared/utils/object';

/** The server's error of a queued change, when it answered with one. */
export function responseErrorOf(response: unknown): unknown {
  return isPlainObject(response) ? response.error : undefined;
}
